import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink} from 'react-router-dom'
import {useIntl} from 'react-intl'

// Components
import {
    Breadcrumb as ChakraBreadcrumb,
    BreadcrumbItem as ChakraBreadcrumbItem,
    BreadcrumbLink as ChakraBreadcrumbLink,
    Link,
    // Hooks
    useStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

// Others
import {categoryUrlBuilder} from '../../utills/url'
import {breadcrumbItemStyle} from './index.style'
import {pxToRem} from '../../utills/pxToRem'

/**
 * A simplification of the Chakra `Breadcrumb` component for our project needs. Given
 * a list of categories, display a breadcrumb and it's items.
 */
const Breadcrumb = ({categories, ...rest}) => {
    const intl = useIntl()
    const styles = useStyleConfig('Breadcrumb')

    return (
        <ChakraBreadcrumb
            marginTop={[pxToRem(0), pxToRem(0), pxToRem(5), pxToRem(5)]}
            marginBottom={[pxToRem(10), pxToRem(10), pxToRem(15), pxToRem(15)]}
            className="sf-breadcrumb"
            {...styles.container}
            separator={<span>/</span>}
            sx={{
                ol: {
                    flexWrap: 'wrap'
                }
            }}
            {...rest}
        >
            <ChakraBreadcrumbItem sx={breadcrumbItemStyle} data-testid="sf-crumb-item">
                <ChakraBreadcrumbLink as={Link} href={'/'} {...styles.link}>
                    {/* <ChakraBreadcrumbLink as={RouteLink} to={'/'} {...styles.link}> */}
                    Home
                </ChakraBreadcrumbLink>
            </ChakraBreadcrumbItem>

            {categories.map((category) => (
                <ChakraBreadcrumbItem
                    sx={breadcrumbItemStyle}
                    key={category.id}
                    data-testid="sf-crumb-item"
                >
                    <ChakraBreadcrumbLink
                        // as={RouteLink}
                        // to={categoryUrlBuilder(category, intl.locale)}
                        as={Link}
                        href={categoryUrlBuilder(category, intl.locale)}
                        {...styles.link}
                    >
                        {category.name
                            ?.toLowerCase()
                            .replace(/(^\w|\s\w|-\w)/g, (match) => match.toUpperCase())}
                    </ChakraBreadcrumbLink>
                </ChakraBreadcrumbItem>
            ))}
        </ChakraBreadcrumb>
    )
}

Breadcrumb.displayName = 'Breadcrumb'

Breadcrumb.propTypes = {
    /**
     * The categories to be displayed in this breadcrumb.
     */
    categories: PropTypes.array
}

export default Breadcrumb
